import { connect } from 'react-redux';
import HeaderBanner from '../HeaderBanner/HeaderBanner';
import { getActiveListingPage } from '../../reduck/selectors';

const mapStateToProps = (state) => ({
  htmlContent: getActiveListingPage(state).banner.htmlContent,
  isMobile: state.listingPage.browser ? state.listingPage.browser.device.deviceType === 'mobile' : false,
  isBrowserRendering: !!state.listingPage.browser
});

export default connect(mapStateToProps)(HeaderBanner);
